const AlertTriggerConditionThresholdTypeEnum = {
  LowerLimit: 'Lower_Limit',
  UpperLimit: 'Upper_Limit'
}
export default AlertTriggerConditionThresholdTypeEnum
